import type { WorkOrder } from '@/types/maintenance';

/** Days since the WO was created — end-to-end lead time measure */
export function queueAgeDays(wo: WorkOrder): number {
  return Math.max(0, Math.round((Date.now() - new Date(wo.created_at).getTime()) / 86400000));
}

/** Human-readable duration: 90 → "1h 30m" */
export function formatDuration(minutes: number): string {
  if (minutes < 60) return `${minutes}m`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}

/** Time since a WO entered its current state */
export function timeInState(wo: WorkOrder): string {
  const ref = wo.blocked_at || wo.start_time || wo.created_at;
  if (!ref) return '';
  const mins = Math.round((Date.now() - new Date(ref).getTime()) / 60_000);
  if (mins < 60) return `${mins}m`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h`;
  return `${Math.round(hrs / 24)}d`;
}

/** Number of days a WO has been blocked */
export function daysBlocked(blockedAt?: string): number {
  if (!blockedAt) return 0;
  return Math.max(1, Math.round((Date.now() - new Date(blockedAt).getTime()) / 86_400_000));
}

export const TYPE_LABELS: Record<string, string> = {
  corrective: 'Corrective',
  preventive: 'Preventive',
  improvement: 'Improvement',
  corrective_in_machine: 'In-Machine',
};
